import { CRM_OBJECT_TYPE_IDS } from './objectTypeIds';
export const TARGETING_KINDS = {
  CONTACT: 'CONTACT',
  COMPANY: 'COMPANY',
  SEGMENT: 'SEGMENT'
};
export const SUPPORTED_TARGETING_KINDS = [TARGETING_KINDS.CONTACT, TARGETING_KINDS.COMPANY, TARGETING_KINDS.SEGMENT];
export const CRM_TARGETING_KIND_TO_OBJECT_TYPE_ID = {
  [TARGETING_KINDS.CONTACT]: CRM_OBJECT_TYPE_IDS.CONTACT,
  [TARGETING_KINDS.COMPANY]: CRM_OBJECT_TYPE_IDS.COMPANY
};
export const OBJECT_TYPE_ID_TO_CRM_TARGETING_KIND = {
  [CRM_OBJECT_TYPE_IDS.CONTACT]: TARGETING_KINDS.CONTACT,
  [CRM_OBJECT_TYPE_IDS.COMPANY]: TARGETING_KINDS.COMPANY
};